/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable array-callback-return */
import {
  Typography,
  useMediaQuery,
  useTheme,
  Card,
  Link,
  Tooltip,
  TooltipProps,
  tooltipClasses,
  styled,
  Divider,
  Grid,
} from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ArticleIcon from "@mui/icons-material/Article";
import { useNavigate } from "react-router-dom";
import Color from "../../theme/color";
import moment from "moment";
import NumberFormat from "../number-format";
import { SkeletonLoader } from "../full-screen-loader";

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

const UpcomingEventsCard = ({ cartData, loading }: any) => {
  const navigate = useNavigate();
  const theme = useTheme<any>();
  const isSmallScreen = useMediaQuery<any>(theme.breakpoints.down("sm"));
  return (
    <Grid
      item
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%",
        justifyContent: "center",
        padding: "0px 0px 50px 0px",
      }}
      xs={12}
    >
      {loading ? (
        <>
          <SkeletonLoader count={9} />
        </>
      ) : (
        cartData?.map((event: any, index: any) => {
          const scheduleListCount = event?.scheduleCount;
          const id = event?.id;
          const start = moment(event?.startDate);
          const end = moment(event?.endDate);
          const imageStyles = {
            flexGrow: 3,
            height: "50%",
            width: "100%",
            objectFit: "cover" as const,
            transition: "transform 0.6s",
          };
          const cardHoverStyle = {
            boxShadow: "0 0 30px rgba(0, 0, 0, 0.1)",
          };

          return (
            <Link
              key={index}
              onClick={() => {
                const targetRoute = event?.eventRouting || event?.id;
                navigate(`/event/${targetRoute}`, {
                  state: {
                    eventId: targetRoute,
                  },
                });
              }}
              style={{
                textDecoration: "none",
                margin: 15,
                borderRadius: "20px",
                transition: "transform 0.8s",
              }}
              sx={{
                "&:hover": { ...cardHoverStyle, transition: "transform 0.8s" },
              }}
              component="button"
            >
              <Card
                key={id}
                style={{
                  borderRadius: "20px",
                  maxWidth: "300px",
                  height: isSmallScreen ? "460px" : "460px",
                  width: "300px",
                  boxShadow: "0 0 20px rgba(0, 0, 0, 0.1)",
                }}
              >
                <img
                  style={imageStyles}
                  src={event?.bannerImagePath}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "scale(1.05)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                />
                <div style={{ padding: 10 }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginLeft: 4,
                      width: "100%",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "80%",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Divider
                        orientation="vertical"
                        variant="middle"
                        sx={{
                          backgroundColor: Color.primary,
                          height: "100%",
                          marginRight: "10px",
                          width: "5px",
                        }}
                      />
                      <div>
                        <Typography
                          sx={{
                            marginTop: "8px",
                            textAlign: "left",
                            fontWeight: 600,
                            fontSize: "17px",
                            color: "#333333",
                            overflow: "hidden",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 1,
                          }}
                        >
                          {event?.title}
                        </Typography>
                        <Typography
                          style={{
                            fontSize: 16,
                            fontWeight: "bold",
                            textAlign: "start",
                            textDecoration: "none",
                            marginTop: "6px",
                            marginBottom: "8px",
                            bottom: 5,
                            right: 10,
                            color: Color.primary,
                          }}
                        >
                          Price Starts From: $
                          <NumberFormat total={event?.minPrice} />
                        </Typography>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "20%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <LightTooltip
                        title={event?.organizerName}
                        placement="top-start"
                      >
                        {event?.organizerProfile === "" ||
                        event?.organizerProfile == null ||
                        event?.organizerProfile === undefined ? (
                          <img
                            style={{
                              height: "40px",
                              width: "40px",
                              borderRadius: "40px",
                              boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                            }}
                            src="https://th.bing.com/th/id/OIP.ATJuETbmpi6W5dai-Wwd2QAAAA?pid=ImgDet&rs=1"
                          />
                        ) : (
                          <img
                            style={{
                              height: "40px",
                              width: "40px",
                              borderRadius: "40px",
                            }}
                            src={event?.organizerProfile}
                          />
                        )}
                      </LightTooltip>
                    </div>
                  </div>
                  <div style={Styles.textBody}>
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <ArticleIcon
                        style={{
                          color: Color.secondary,
                          marginRight: 1,
                          marginTop: 1,
                          height: isSmallScreen ? 17 : 17,
                        }}
                      />
                      <Typography fontSize={14}>
                        Organized By: {event?.organizerName}
                      </Typography>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: 6,
                      marginBottom: 6,
                    }}
                  >
                    <div>
                      <PlaceIcon
                        style={{
                          color: Color.secondary,
                          marginRight: 2,
                          marginTop: 2,
                          height: isSmallScreen ? 17 : 19,
                        }}
                      />
                    </div>

                    <Typography
                      style={{
                        textAlign: "left",
                        fontSize: "14px",
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                        margin: "1px",
                      }}
                    >
                      {event?.address1}, {event?.city}, {event?.state},{" "}
                      {event?.country}, {event?.zipCode}
                    </Typography>
                  </div>
                  <div style={Styles.textBody}>
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <AccessTimeIcon
                        style={{
                          color: Color.secondary,
                          marginRight: 3,
                          marginTop: 1,
                          height: isSmallScreen ? 17 : 17,
                        }}
                      />
                      <div
                        style={{
                          display: "block",
                        }}
                      >
                        <Typography fontSize={14}>
                          <Typography
                            style={{
                              display: "flex",
                            }}
                            fontSize={14}
                          >
                            {start.format("ddd MMM D, YYYY, h:mm A")} -
                          </Typography>
                          <Typography
                            style={{
                              display: "flex",
                            }}
                            fontSize={14}
                          >
                            {end.format("ddd MMM D, YYYY, h:mm A")}{" "}
                            <Typography
                              style={{
                                color: Color.color13,
                                marginLeft: "3px",
                              }}
                              fontWeight={300}
                              fontSize={12}
                            >
                              ({event?.abbreviation})
                            </Typography>
                          </Typography>
                        </Typography>{" "}
                      </div>
                    </div>
                  </div>
                  {scheduleListCount !== 1 ? (
                    <div
                      style={{
                        display: "flex",
                        marginLeft: "28px",
                      }}
                    >
                      <Typography
                        color={Color.secondary}
                        style={{ textDecoration: "underline" }}
                        fontSize={14}
                      >
                        Multi Day Event
                      </Typography>{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </Card>
            </Link>
          );
        })
      )}
    </Grid>
  );
};

export default UpcomingEventsCard;

const Styles: any = {
  textBody: {
    display: "flex",
    flexDirection: "row",
  },
};
